import { Chip as MuiChip, ChipProps as MuiChipProps } from "@mui/material";

export type ChipProps = MuiChipProps;

export const Chip = ({ children, ...props }: ChipProps) => {
  return <MuiChip {...{ ...props, size: "small" }}>{children}</MuiChip>;
};
